import React from 'react';

/**
 * Bottom info overlay for shorts viewer
 * Shows speaker handle and video title only
 * Series name is now displayed only in top navigation
 */
const ShortsInfo = ({ 
  speakerName, 
  title,
  publishedAt
}) => {
  
  // Generate speaker handle from name
  const getSpeakerHandle = (name) => {
    if (!name) return '@Speaker';
    // Convert "Sheikh Ahmed Ali" to "@SheikhAhmedAli"
    return '@' + name.replace(/\s+/g, '');
  };
  
  // Format date for display
  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    try {
      const date = new Date(dateStr);
      const options = { month: 'short', day: 'numeric', year: 'numeric' };
      return date.toLocaleDateString('en-US', options);
    } catch (err) {
      return '';
    }
  };

  // Truncate title to max 2 lines (approximately 80 characters on mobile)
  const truncateTitle = (text, maxLength = 80) => {
    if (!text) return 'Untitled';
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength - 3) + '...';
  };

  return (
    <div className="shorts-info">
      {/* Gradient overlay for text readability */}
      <div className="info-gradient"></div>
      
      <div className="info-content">
        {/* Speaker Handle with Date */}
        <div className="speaker-handle">
          {getSpeakerHandle(speakerName)}
          {publishedAt && (
            <span className="speaker-date"> - {formatDate(publishedAt)}</span>
          )}
        </div>
        
        {/* Video Title (max 2 lines) */}
        <div className="video-title">
          {truncateTitle(title)}
        </div>
      </div>
    </div>
  );
};

export default ShortsInfo;